// extracted by mini-css-extract-plugin
export default {"spine-menu-container":"SpineMenuCsb_spine-menu-container__0p-Y4","spine-navigation":"SpineMenuCsb_spine-navigation__zrjmA","spine-content":"SpineMenuCsb_spine-content__IWnpa"};